var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper wrapper-full-page full-page",staticStyle:{"min-height":"100% !important"}},[_c('div',{staticClass:"page-header header-filter login-page",style:(_vm.headerStyle)},[_c('router-view')],1),_c('content-footer',{staticClass:"landing-footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }